import React from 'react';
import ApplicationsTableFilterPopover from '€components/ApplicationsTableFilterPopover';
import { Box, Toolbar } from '@material-ui/core';
import { useToolbarStyles } from './styles';
import ApplicationsTableExport from '€components/ApplicationsTableExport';
import { ApplicationsTableToolbarProps } from '€lib/types/ApplicationsTableTypes';

export default function ApplicationsTableToolbar({
    headerGroups,
    preGlobalFilteredRows,
    globalFilter,
    setGlobalFilter,
    rows,
    setAllFilters,
}: ApplicationsTableToolbarProps) {
    const classes = useToolbarStyles();

    return (
        <Toolbar className={classes.root}>
            <Box display="flex" justifyContent="flex-end">
                <ApplicationsTableFilterPopover
                    headerGroups={headerGroups}
                    preGlobalFilteredRows={preGlobalFilteredRows}
                    globalFilter={globalFilter}
                    setGlobalFilter={setGlobalFilter}
                    setAllFilters={setAllFilters}
                />
                <ApplicationsTableExport rows={rows} />
            </Box>
        </Toolbar>
    );
}
